import { useState, useEffect, useCallback } from "react";
import { IoPeopleOutline, IoAddOutline } from "react-icons/io5";
import Toaster from "./../../../../components/common/Toaster";
import Modal from "./../../../../components/common/Modal";
import referralService from "./../../../../services/referralService";
import moment from "moment";
import ReferralForm from "./components/ReferralForm";

const AccountReferrals = ({ id }) => {
  const [referrals, setReferrals] = useState([]);

  const [showForm, setShowForm] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const fetchReferrals = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const { result } = await referralService.getAccountReferralsAsync(id);

        if (mounted) {
          setReferrals(result);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [id]
  );

  const handleSuccess = (item) => {
    setReferrals([item, ...referrals]);
    setShowForm(false);
  };

  useEffect(() => {
    let mounted = true;

    fetchReferrals(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchReferrals]);

  return (
    <div className="p-5">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-500">Account Referrals</p>
          <span className="text-xs text-gray-400">
            List of Account Referrals
          </span>
        </div>
        <IoAddOutline
          className="text-blue-500 text-lg cursor-pointer"
          onClick={() => setShowForm(true)}
        />
      </div>
      <div className="mt-6 mb-4">
        {isLoading && (
          <div className="flex-1 space-y-3 py-1 animate-pulse">
            <div className="h-4 bg-gray-100 rounded w-3/5"></div>
            <div className="h-4 bg-gray-100 rounded w-5/5"></div>
            <div className="h-4 bg-gray-100 rounded w-4/5"></div>
            <div className="h-4 bg-gray-100 rounded w-2/5"></div>
          </div>
        )}
        {!isLoading && referrals.length > 0 && (
          <ul className="border border-gray-200 rounded-md divide-y divide-gray-200">
            {referrals.map((item, index) => (
              <li
                key={index}
                className="pl-3 pr-4 py-3 flex items-center text-gray-400 text-sm"
              >
                <div>
                  <p>{item.referee_name}</p>
                  <span className="text-xs">
                    {moment(item.created_on).format("YYYY-MM-DD")}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        )}
        {!isLoading && referrals.length === 0 && (
          <div className="text-center bg-gray-50 p-8 rounded-xl mb-2">
            <div className="flex justify-center">
              <div>
                <IoPeopleOutline className="text-3xl inline text-gray-300" />
                <p className="text-gray-400 text-sm mt-3">Nothing to show</p>
                <span className="text-gray-400 text-xs">
                  Account referrals will appear here
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      <Modal
        title="Assign Referral"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <ReferralForm
          id={id}
          isLoading={isFormLoading}
          setLoading={setIsFormLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default AccountReferrals;
